/* COLPI DI TESTA — theme.js (vanilla, nessuna dipendenza) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const CDT = window.CDT || { routes: {}, strings: {} };
  /* Panels (menu, search, filters) must live directly in <body>: a sticky/z-indexed
     section would trap them under the dark overlay. */
  function hoistPanels(scope) {
    $$('.drawer, .search-modal', scope).forEach(el => {
      if (el.id === 'CartDrawer' || el.parentElement === document.body) return;
      const old = el.id && document.body.querySelector(':scope > #' + CSS.escape(el.id));
      if (old && old !== el) old.remove();
      document.body.appendChild(el);
    });
  }
  hoistPanels(document);
  document.addEventListener('shopify:section:load', e => hoistPanels(e.target));

  const overlay = $('[data-overlay]');
  let openLayer = null;

  /* ---------- overlay / layers ---------- */
  function openPanel(el) {
    if (!el) return;
    closePanel();
    openLayer = el;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-visible')); }
    document.body.classList.add('is-locked');
    const f = el.querySelector('input[type="search"], button, a');
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 320);
  }
  function closePanel() {
    if (!openLayer) return;
    const el = openLayer;
    el.classList.remove('is-open');
    openLayer = null;
    if (overlay) { overlay.classList.remove('is-visible'); setTimeout(() => { if (!openLayer) overlay.hidden = true; }, 400); }
    document.body.classList.remove('is-locked');
    setTimeout(() => { if (openLayer !== el) el.hidden = true; }, 500);
  }
  window.CDT_open = openPanel;
  overlay && overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closePanel(); closeLightbox(); closePopup(); } });
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openPanel(document.getElementById(opener.dataset.open)); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanel(); }
  });

  /* ---------- header ---------- */
  const headerWrap = $('[data-header]');
  if (headerWrap) {
    const setH = () => document.documentElement.style.setProperty('--header-h', Math.round(headerWrap.getBoundingClientRect().height) + 'px');
    const onScroll = () => { headerWrap.classList.toggle('is-scrolled', window.scrollY > 40); setH(); };
    window.addEventListener('resize', setH);
    headerWrap.addEventListener('transitionend', setH);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  $$('.nav__item[data-has-mega] > .nav__link').forEach(link => {
    link.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') { e.preventDefault(); link.parentElement.classList.add('is-open'); const a = link.parentElement.querySelector('.mega a'); a && a.focus(); }
    });
  });
  $$('.nav__item[data-has-mega]').forEach(item => item.addEventListener('mouseleave', () => item.classList.remove('is-open')));

  /* mobile accordion */
  $$('[data-mnav-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const sub = document.getElementById(btn.getAttribute('aria-controls'));
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (sub) sub.hidden = open;
  }));

  /* ---------- announcement rotation ---------- */
  $$('[data-announce]').forEach(box => {
    const items = $$('p', box); if (items.length < 2) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4500);
  });

  /* ---------- slideshow ---------- */
  $$('[data-slideshow]').forEach(show => {
    const slides = $$('.slide', show); if (!slides.length) return;
    const count = $('[data-slide-count]', show);
    const dur = parseInt(show.dataset.speed || '6', 10) * 1000;
    const auto = show.dataset.autoplay === 'true' && slides.length > 1;
    let i = 0, timer;
    show.style.setProperty('--dur', dur / 1000 + 's');
    const go = n => {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
      if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      restart();
    };
    const restart = () => {
      clearTimeout(timer);
      if (!auto) return;
      show.classList.remove('is-playing'); void show.offsetWidth; show.classList.add('is-playing');
      timer = setTimeout(() => go(i + 1), dur);
    };
    $('[data-slide-prev]', show)?.addEventListener('click', () => go(i - 1));
    $('[data-slide-next]', show)?.addEventListener('click', () => go(i + 1));
    let x0 = null;
    show.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 45) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    show.addEventListener('mouseenter', () => { clearTimeout(timer); show.classList.remove('is-playing'); });
    show.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------- carousels ---------- */
  function initCarousel(root) {
    const track = $('.carousel__track', root); if (!track) return;
    const prev = $('[data-car-prev]', root), next = $('[data-car-next]', root), bar = $('.carousel__progress span', root);
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) { const w = Math.max(track.clientWidth / track.scrollWidth * 100, 8); bar.style.width = w + '%'; bar.style.left = (max > 0 ? track.scrollLeft / max : 0) * (100 - w) + '%'; }
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- reveal on scroll ---------- */
  if (document.body.classList.contains('has-anim') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    const watch = scope => $$('[data-anim]:not(.is-in)', scope).forEach((el, n) => { el.style.transitionDelay = (n % 4) * 70 + 'ms'; io.observe(el); });
    watch(document);
    window.CDT_watch = watch;
  } else {
    $$('[data-anim]').forEach(el => el.classList.add('is-in'));
    window.CDT_watch = scope => $$('[data-anim]', scope).forEach(el => el.classList.add('is-in'));
  }

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = CDT.moneyFormat || '€{{amount_with_comma_separator}}';
    const n = (cents / 100);
    const withComma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const withDot = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({ amount: withDot, amount_no_decimals: Math.round(n).toString(), amount_with_comma_separator: withComma, amount_no_decimals_with_comma_separator: Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }[k] || withComma));
  }

  /* ---------- toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  }

  /* ---------- cart ---------- */
  const drawer = $('#CartDrawer');
  async function refreshCart(open) {
    try {
      const res = await fetch(`${CDT.routes.root || '/'}?section_id=cart-drawer`.replace('//?', '/?'));
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawer');
      if (fresh && drawer) {
        drawer.querySelector('[data-cart-body]').innerHTML = fresh.querySelector('[data-cart-body]').innerHTML;
        drawer.querySelector('[data-cart-foot]').innerHTML = fresh.querySelector('[data-cart-foot]').innerHTML;
        const c = fresh.querySelector('[data-cart-title-count]'); const t = drawer.querySelector('[data-cart-title-count]');
        if (c && t) t.textContent = c.textContent;
      }
      const cart = await (await fetch(`${CDT.routes.cart}.js`)).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (open && drawer && CDT.cartType === 'drawer') openPanel(drawer);
      return cart;
    } catch (e) { console.error(e); }
  }
  window.CDT_refreshCart = refreshCart;

  async function addToCart(formData, btn) {
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(`${CDT.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || CDT.strings.error);
      if (CDT.cartType === 'page') { window.location.href = CDT.routes.cart; return; }
      await refreshCart(true);
      toast(CDT.strings.added || 'Aggiunto al carrello');
    } catch (err) {
      toast(err.message || CDT.strings.error);
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
    }
  }

  document.addEventListener('submit', e => {
    const form = e.target;
    if (form.matches('[data-quick-add], [data-product-form]')) {
      if (CDT.cartType === 'page' && form.matches('[data-product-form]')) return;
      e.preventDefault();
      addToCart(new FormData(form), form.querySelector('[type="submit"]'));
    }
  });

  async function changeLine(line, quantity) {
    drawer && drawer.classList.add('is-loading');
    try {
      await fetch(`${CDT.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      await refreshCart(false);
    } finally { drawer && drawer.classList.remove('is-loading'); }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line-qty]');
    if (b) {
      e.preventDefault();
      const line = parseInt(b.dataset.line, 10);
      const input = b.parentElement.querySelector('input');
      const q = Math.max(0, parseInt(input.value, 10) + parseInt(b.dataset.lineQty, 10));
      changeLine(line, q); return;
    }
    const r = e.target.closest('[data-line-remove]');
    if (r) { e.preventDefault(); changeLine(parseInt(r.dataset.line, 10), 0); }
  });
  document.addEventListener('change', e => {
    const inp = e.target.closest('[data-line-input]');
    if (inp) changeLine(parseInt(inp.dataset.line, 10), Math.max(0, parseInt(inp.value, 10) || 0));
  });

  /* ---------- quantity (product form) ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(root => {
    const json = $('script[data-product-json]', root) || $('script[data-product-json]', root.closest('.shopify-section') || document);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('[data-product-form]', root);
    const idInput = form && form.querySelector('input[name="id"]');
    const btn = form && form.querySelector('[data-atc]');
    const priceBox = $('[data-price-wrap]', root);
    const skuBox = $('[data-sku]', root);
    const sticky = $('[data-sticky-atc]');

    const selected = () => $$('fieldset[data-option-index]', root).map(fs => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
    const findVariant = vals => product.variants.find(v => v.options.every((o, i) => o === vals[i]));

    function updateAvailability(vals) {
      $$('fieldset[data-option-index]', root).forEach(fs => {
        const idx = parseInt(fs.dataset.optionIndex, 10);
        $$('input', fs).forEach(inp => {
          const test = vals.slice(); test[idx] = inp.value;
          const v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
        const lab = fs.querySelector('[data-selected-value]'); const c = fs.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
      });
    }

    const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const colorIndex = $$('fieldset[data-option-index]', root).findIndex(fs => /^(colore|color|colour|colori|tinta)$/i.test((fs.querySelector('legend')?.firstChild?.textContent || '').trim()));
    function mediaForVariant(v) {
      if (v.featured_media && v.featured_media.id) return v.featured_media.id;
      const media = product.media || [];
      const values = colorIndex >= 0 ? [v.options[colorIndex]] : v.options;
      for (const val of values) {
        const key = norm(val);
        if (!key) continue;
        const re = new RegExp('(^|\\s)' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)');
        const byAlt = media.find(m => re.test(norm(m.alt)));
        if (byAlt) return byAlt.id;
        const byFile = media.find(m => re.test(norm(m.file)));
        if (byFile) return byFile.id;
      }
      if (product.variants[0] && v.id === product.variants[0].id && media[0]) return media[0].id;
      return null;
    }

    function render(v) {
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = CDT.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? CDT.strings.addToCart : CDT.strings.soldOut; }
      if (priceBox) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceBox.innerHTML = `<div class="price${sale ? ' price--sale' : ''}${v.available ? '' : ' price--soldout'}">${sale ? `<s class="price__compare">${money(v.compare_at_price)}</s>` : ''}<span class="price__current">${money(v.price)}</span></div>`;
        if (sticky) { const sp = sticky.querySelector('[data-sticky-price]'); if (sp) sp.innerHTML = priceBox.innerHTML; }
      }
      if (skuBox) { skuBox.hidden = !v.sku; const s = skuBox.querySelector('span'); if (s) s.textContent = v.sku || ''; }
      const mediaId = mediaForVariant(v);
      if (mediaId) {
        const slide = root.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide) goToSlide(root, parseInt(slide.dataset.index, 10));
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }

    root.addEventListener('change', e => {
      if (!e.target.closest('fieldset[data-option-index]')) return;
      const vals = selected(); updateAvailability(vals); render(findVariant(vals));
    });
    updateAvailability(selected());
    if (new URLSearchParams(location.search).get('variant')) {
      const v0 = findVariant(selected());
      const mid = v0 && mediaForVariant(v0);
      if (mid) { const s = root.querySelector(`[data-media-id="${mid}"]`); if (s) setTimeout(() => goToSlide(root, parseInt(s.dataset.index, 10)), 50); }
    }

    if (sticky && btn) {
      const sbtn = sticky.querySelector('button');
      sbtn && sbtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit(btn) : btn.click());
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
      io.observe(btn);
    }
  });

  /* gallery */
  function goToSlide(root, n) {
    const track = $('.gallery__track', root); if (!track) return;
    const slides = $$('.gallery__slide', track); if (!slides[n]) return;
    const left = n * track.clientWidth;
    try { track.scrollTo({ left, behavior: 'smooth' }); } catch (_) { track.scrollLeft = left; }
    setTimeout(() => { if (Math.abs(track.scrollLeft - left) > 2) track.scrollLeft = left; }, 600);
    const g = track.closest('[data-gallery]');
    if (g) $$('.gallery__thumb', g).forEach((t, i) => t.classList.toggle('is-active', i === n));
  }
  $$('[data-gallery]').forEach(g => {
    const track = $('.gallery__track', g); if (!track) return;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('.gallery__thumb', g);
    const count = $('[data-gallery-count]', g);
    let cur = 0;
    const sync = () => {
      cur = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === cur));
      if (count) count.textContent = `${cur + 1} / ${slides.length}`;
    };
    track.addEventListener('scroll', () => { clearTimeout(track._t); track._t = setTimeout(sync, 60); }, { passive: true });
    thumbs.forEach((t, i) => t.addEventListener('click', () => goToSlide(g.closest('[data-product]') || g, i)));
    $('[data-gal-prev]', g)?.addEventListener('click', () => goToSlide(g, (cur - 1 + slides.length) % slides.length));
    $('[data-gal-next]', g)?.addEventListener('click', () => goToSlide(g, (cur + 1) % slides.length));
    slides.forEach(s => s.addEventListener('click', () => { const src = s.dataset.zoom; if (src) openLightbox(src); }));
    $('[data-gal-zoom]', g)?.addEventListener('click', () => { const s = slides[cur]; s && s.dataset.zoom && openLightbox(s.dataset.zoom); });
    sync();
  });
  let lb;
  function openLightbox(src) {
    lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = `<button class="lightbox__close" type="button" aria-label="Chiudi"><svg class="icon" viewBox="0 0 24 24"><path d="m5 5 14 14M19 5 5 19" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button><img src="${src}" alt="">`;
    lb.addEventListener('click', closeLightbox);
    document.body.appendChild(lb); document.body.classList.add('is-locked');
    requestAnimationFrame(() => { lb.scrollLeft = (lb.scrollWidth - lb.clientWidth) / 2; lb.scrollTop = (lb.scrollHeight - lb.clientHeight) / 2; });
  }
  function closeLightbox() { if (lb) { lb.remove(); lb = null; if (!openLayer) document.body.classList.remove('is-locked'); } }

  /* share */
  $$('[data-share]').forEach(b => b.addEventListener('click', async e => {
    if (navigator.share) { e.preventDefault(); try { await navigator.share({ title: document.title, url: location.href }); } catch (_) {} }
  }));

  /* ---------- recently viewed ---------- */
  const RV_KEY = 'cdt_recent';
  const current = $('[data-recent-handle]');
  let recent = [];
  try { recent = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (_) {}
  if (current) {
    const h = current.dataset.recentHandle;
    recent = [h].concat(recent.filter(x => x !== h)).slice(0, 12);
    try { localStorage.setItem(RV_KEY, JSON.stringify(recent)); } catch (_) {}
  }
  $$('[data-recently-viewed]').forEach(async box => {
    const exclude = box.dataset.exclude;
    const handles = recent.filter(h => h !== exclude).slice(0, parseInt(box.dataset.limit || '8', 10));
    if (!handles.length) return;
    const q = handles.map(h => `handle:${h}`).join(' OR ');
    try {
      const res = await fetch(`${CDT.routes.root.replace(/\/$/, '')}/search?q=${encodeURIComponent(q)}&type=product&section_id=${box.dataset.sectionId}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = doc.querySelector('[data-recent-items]');
      if (items && items.children.length) {
        box.querySelector('.carousel__track').innerHTML = items.innerHTML;
        box.closest('section').hidden = false;
        window.CDT_watch && window.CDT_watch(box);
        initCarousel(box);
      }
    } catch (_) {}
  });

  /* ---------- related products ---------- */
  $$('[data-related]').forEach(async box => {
    try {
      const res = await fetch(box.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related]');
      if (fresh && fresh.querySelector('.card')) {
        box.innerHTML = fresh.innerHTML;
        window.CDT_watch && window.CDT_watch(box);
        $$('[data-carousel]', box).forEach(initCarousel);
      }
    } catch (_) {}
  });

  /* ---------- collection filters ---------- */
  const facetForm = $('[data-facet-form]');
  if (facetForm) {
    let t;
    const apply = () => {
      const fd = new FormData(facetForm);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') params.append(k, v); }
      const sort = $('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
      window.location.search = params.toString();
    };
    facetForm.addEventListener('change', e => { if (e.target.type === 'number') return; clearTimeout(t); t = setTimeout(apply, 250); });
    facetForm.addEventListener('submit', e => { e.preventDefault(); apply(); });
  }
  $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page'); window.location.href = url;
  }));

  /* ---------- localization selects ---------- */
  $$('[data-localization] select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* ---------- newsletter popup ---------- */
  const popup = $('[data-popup]');
  function closePopup() {
    if (!popup || !popup.classList.contains('is-open')) return;
    popup.classList.remove('is-open'); document.body.classList.remove('is-locked');
    try { localStorage.setItem('cdt_popup', String(Date.now())); } catch (_) {}
    setTimeout(() => { popup.hidden = true; }, 450);
  }
  if (popup) {
    const days = parseInt(popup.dataset.days || '7', 10);
    let last = 0; try { last = parseInt(localStorage.getItem('cdt_popup') || '0', 10); } catch (_) {}
    const posted = popup.querySelector('.form-msg--ok');
    const show = () => { popup.hidden = false; requestAnimationFrame(() => popup.classList.add('is-open')); document.body.classList.add('is-locked'); };
    if (posted) show();
    else if (Date.now() - last > days * 864e5 && !window.Shopify?.designMode) setTimeout(show, parseInt(popup.dataset.delay || '6', 10) * 1000);
    popup.addEventListener('click', e => { if (e.target === popup || e.target.closest('[data-popup-close]')) closePopup(); });
    document.addEventListener('shopify:section:select', e => { if (popup.closest('.shopify-section')?.id === 'shopify-section-' + e.detail.sectionId) show(); });
    document.addEventListener('shopify:section:deselect', e => { if (popup.closest('.shopify-section')?.id === 'shopify-section-' + e.detail.sectionId) closePopup(); });
  }

  /* re-init in theme editor */
  document.addEventListener('shopify:section:load', e => {
    $$('[data-carousel]', e.target).forEach(initCarousel);
    window.CDT_watch && window.CDT_watch(e.target);
    $$('[data-anim]', e.target).forEach(el => el.classList.add('is-in'));
  });
})();
